var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg352(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "34px",
    viewBox: "0 0 60 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Player-Added-+-Player's-List-(After-Dragging)-(Desktop)",
    transform: "translate(-205.000000, -306.000000)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy-5",
    transform: "translate(235.000000, 323.000000) rotate(-180.000000) translate(-235.000000, -323.000000) translate(205.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 56,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 17,
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg352);
export default __webpack_public_path__ + "static/media/3-5-2.a9bd29cc4306c4fe594371360a9bd896.svg";
export { ForwardRef as ReactComponent };